import Home from "element/Home";

function App() {
  return (
    <div className="App">
      <Home />
      </div>
  );
}

export default App;